<div class="container">
    <app-policy [style]="'text'" (showAgreement)="isShowAgreement = !isShowAgreement"></app-policy>
</div>
